import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initMediaSlider = () => {
  const slider = document.querySelector(".media__swiper");
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(slider, {
        speed: 200,
        loop: true,
        lazy: true,
        breakpoints: {
          1441: {
            slidesPerView: 4,
            spaceBetween: 20,
            centeredSlides: true,
            initialSlide: 1,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 10,
            centeredSlides: true,
          },
          751: {
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 20,
            initialSlide: 2,
          },
          665: {
            slidesPerView: 2,
            spaceBetween: 10,
            centeredSlides: false,
          },
          360: {
            slidesPerView: 1.3,
            spaceBetween: 20,
            centeredSlides: false,
          },
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: true,
          },
        },

        pagination: {
          el: ".media .media__pagination",
          type: "fraction",
        },

        navigation: {
          nextEl: ".media .media__next",
          prevEl: ".media .media__prev",
        },
      });
    }
  }

  init();

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper() {
    window.addEventListener(
      "resize",
      function () {
        destroy();
        init();
      },
      true
    );
  }

  slider && resizeSwiper();
};

export default initMediaSlider;
